// src/frontend/data/books/DarkForest/data/cap15.js

const CAP15 = {
  id: 15,
  title: "Seguridad en NFT",
  sections: [
    {
      heading: "Qué es la seguridad en NFT",
      text: [
        "Todo lo que ya hemos mencionado sobre seguridad en DeFi aplica también al mundo de los NFT. Al final, un marketplace de NFT no deja de ser una DApp que interactúa con contratos inteligentes y con tu billetera.",
        "Sin embargo, los NFT tienen algunas particularidades de seguridad que los hacen especiales: la forma en que guardan imágenes y metadatos, la manera en que se firman las órdenes de compra/venta, y la cantidad de firmas “raras” que un usuario normal termina aceptando sin entender.",
        "En este capítulo veremos dos ejes principales:",
         "🔹 Seguridad del metadata (imágenes, videos, atributos).",
         "🔹 Seguridad de las firmas (qué estás autorizando realmente cuando aceptas firmar)."
      ]
    },
    {
      heading: "Seguridad del metadata",
      text: [
        "Cuando hablamos de metadata en NFT, nos referimos a la información que describe al token: la imagen o animación, el nombre, la descripción, los atributos, los enlaces externos, etc. Muchos marketplaces siguen las convenciones de OpenSea:",
        "https://docs.opensea.io/docs/metadata-standards",
        "Desde el punto de vista de seguridad, hay dos preocupaciones principales:",
        "1) Confiabilidad del URI de la imagen (o del media).",
        "2) Privacidad y recolección de datos del usuario al cargar ese recurso."
      ]
    },
    {
      heading: "Problema 1: URIs centralizados y mutables",
      text: [
        "Un error típico de muchos proyectos NFT es apuntar las imágenes o animaciones a un servicio centralizado poco fiable, por ejemplo:",
         "🔹 Un servidor web privado del equipo del proyecto.",
         "🔹 Un bucket en la nube sin controles claros.",
         "🔹 Un CDN poco documentado.",
        "El riesgo es doble:",
         "🔹 No hay garantía de disponibilidad: si el servidor cae, migra o se abandona, tus NFT se quedarán con una imagen rota.",
         "🔹 No hay garantía de inmutabilidad: el proyecto puede cambiar las imágenes a voluntad, y tu \"coleccionable digital\" deja de ser realmente inmutable.",
        "Por eso, es buena práctica usar soluciones de almacenamiento descentralizado como IPFS o Arweave, y elegir gateways conocidos y confiables para exponer esos recursos en la web.",
        "Como usuario, si un proyecto serio publica la colección en un repositorio público (por ejemplo, un JSON en IPFS) y documenta claramente cómo se genera el metadata, es una buena señal."
      ]
    },
    {
      heading: "Problema 2: filtraciones de privacidad vía imágenes",
      text: [
        "Cada vez que tu navegador carga una imagen o un JSON de metadata desde una URL remota, se envía cierta información técnica al servidor de origen:",
         "🔹 Dirección IP.",
         "🔹 Navegador (User-Agent).",
         "🔹 Hora aproximada.",
         "🔹 Posibles cabeceras adicionales.",
        "Un proyecto malicioso o descuidado podría usar ese endpoint de imágenes para perfilar a los usuarios: cuándo abren la colección, desde qué país, qué wallets suelen interactuar con ese marketplace, etc.",
        "Esto no significa que ver un NFT sea automáticamente peligroso, pero sí implica que las colecciones deberían pensar también en la capa de privacidad. Un endpoint profesional debe tratar los logs con cuidado y evitar exponer datos personales innecesarios."
      ]
    },
  ]
};

export default CAP15;
